import { collection, query, getDocs } from "firebase/firestore";
import { useQuery } from "@tanstack/react-query";

import { db } from "../../config/firebase";

export const useDownloadFrequency = () =>
  useQuery({
    queryKey: ["downloadfrequency"],
    queryFn: async () => {
      try {
        const q = query(collection(db, "downloadfrequency"));
        const querySnapshot = await getDocs(q);
        return querySnapshot.docs;
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
  });
